<template>
  <div>
    <Modal v-model="show" :title="'客户详情'" :styles="{top: '20px'}" @on-cancel="close" :mask-closable="false" width="1300" :closable='false'>
      <div class="project">
        <!-- 项目 -->
        <div class="top">
          <Row>
            <Col span="5">
            客户名称：{{form.c客户名}}
            </Col>
            <Col span="6">
            客户简名：{{form.simpleName}}
            </Col>
            <Col span="5">
            企业性质： {{form.enterpriseNatureText}}
            </Col>
			<Col span="5">
			省份： {{form.provinceText}}
			</Col>
			<Col span="5">
			客户法人： {{form.legalPerson}}
			</Col>
			<Col span="5">
			税号： {{form.dutyParagraph}}
			</Col>
            <Col :span="6">
            状态：{{form.statusText}}
            </Col>
            <Col span="6">
            创建时间： {{form.creationTimeText}}
            </Col>
          </Row>
        </div>
        <!-- 联系人 -->
        <Tabs value="name1" name="tab1"  @on-click="handleTabClick">
          <TabPane label="联系人" name="name1" tab="tab1">
            <div v-for="(product,index) in form.customerContactsList" :key="index" class="product" :name="index">
              <div class="top">
                <Row>
                  <Col span="5">
                  联系人：{{product.c联系人}}
                  </Col>
                  <Col span="4">
                  职位： {{product.c职位}}
                  </Col>
                  <Col span="5">
                  电话： {{product.c电话}}
                  </Col>
                </Row>
              </div>
              <div>
              </div>
            </div>
          </TabPane>
          <!-- 合同信息 -->
          <TabPane label="合同信息" tab="tab1" name="name2">
			  <div v-if="tabName==='name2'">
				<ContractDetail :customerId="form.id" :isDetail="!isDetail"></ContractDetail>
			  </div>
			 <!-- <div v-for="(product,index) in form.customerContractList" :key="index" class="product" :name="index">
			   <div class="top">
			     <Row>
			       <Col span="5">
			       签订方式：{{product.signingModeText}}
			       </Col>
			       <Col span="4">
			       签订周期： {{product.signingCycleText}}
			       </Col>
			       <Col span="5">
			       付款方式： {{product.payTypeText}}
			       </Col>
				   <Col span="5">
				   账期： {{product.accountPeriodText}}
				   </Col>
			     </Row>
			   </div>
			   <div>
			   </div>
			 </div> -->
          </TabPane>
          <!-- 报价信息 -->
          <TabPane label="报价信息" tab="tab1" name="name3">
			  <div v-if="tabName==='name3'">
					<QuotationDetail :customerId="form.id" :isDetail="!isDetail"></QuotationDetail>
			  </div>
			 <!-- <div v-for="(product,index) in form.customerQuotationList" :key="index" class="product" :name="index">
			   <div class="top">
				 <Row>
				   <Col span="5">
				   报价模板：{{product.quotationTtemplateText}}
				   </Col>
				   <Col span="4">
				   联系人： {{product.contactsIdsText}}
				   </Col>
				   <Col span="5">
				   报价类型： {{product.quotationTypeText}}
				   </Col>
				   <Col span="5">
				   投标流程： {{product.biddingProcess}}
				   </Col>
				 </Row>
			   </div>
			   <div>
			   </div>
			 </div> -->
          </TabPane>
          <!-- 结算信息 -->
          <TabPane label="结算信息" tab="tab1" name="name4">
			  <div v-if="tabName==='name4'">
					<SettlementDetail :customerId="form.id" :isDetail="!isDetail"></SettlementDetail>
			  </div>
			  
			 <!-- <div v-for="(product,index) in form.customerSettlementList" :key="index" class="product" :name="index">
			   <div class="top">
				 <Row>
				   <Col span="5">
				   受理部门：{{product.acceptanceDept}}
				   </Col>
				   <Col span="4">
				   联系人： {{product.contactsIdsText}}
				   </Col>
				   <Col span="5">
				   结算方式： {{product.settlementMethodText}}
				   </Col>
				   <Col span="5">
				   结款流程： {{product.paymentProcess}}
				   </Col>
				 </Row>
			   </div>
			   <div>
			   </div>
			 </div> -->
          </TabPane>
          <!-- 售后信息 -->
          <TabPane label="售后信息" tab="tab1" name="name5">
			  <div v-if="tabName==='name5'">
				<AfterSalesDetail :customerId="form.id" :isDetail="!isDetail"></AfterSalesDetail>
			  </div>
			 <!-- <div v-for="(product,index) in form.customerAfterSalesList" :key="index" class="product" :name="index">
			   <div class="top">
				 <Row>
				   <Col span="4">
				   联系人： {{product.contactsIdsText}}
				   </Col>
				   <Col span="5">
				   售后着装：{{product.afterSalesAttireText}}
				   </Col>
				   <Col span="5">
				   工具： {{product.toolText}}
				   </Col>
				   <Col span="5">
				   人员安全： {{product.personnelSafetyText}}
				   </Col>
				   <Col span="5">
				   车辆入场需知： {{product.vehicleEntryNotice}}
				   </Col>
				 </Row>
			   </div>
			   <div>
			   </div>
			 </div> -->
          </TabPane>
          <!-- 操作日志 -->
          <TabPane label="操作日志" tab="tab1" name="name6">
            <Timeline>
              <TimelineItem v-for="(log,index) in form.businessLogList" :key="index">
                <p class="time">{{log.creatorName}}<span style="margin-left:10px;color:#b6b6b6;">{{log.creationTimeText}}</span></p>
                <p class="content"><span>{{log.content}}</span><span v-if="log.description">：{{log.description}}</span></p>
              </TimelineItem>
            </Timeline>
          </TabPane>
        </Tabs>
      </div>
      <Spin size="large" fix v-show="spinShow"></Spin>
	  <div slot="footer" v-if="examineName=='财务审核'">
		  <Button @click="close()" class="close-btn">关闭</Button>
	    <Button style="width: 80px;" type="success" @click="passCW">通过</Button>
	    <Button style="width: 80px;" @click="noPassCW" type="error">不通过</Button>
	  </div>
	  <div slot="footer" v-else-if="examineName=='执行董事审核'">
		  <Button @click="close()" class="close-btn">关闭</Button>
	    <Button style="width: 80px;" type="success" @click="passZXDS">通过</Button>
	    <Button style="width: 80px;" @click="noPassZXDS" type="error">不通过</Button>
	  </div>
      <div slot="footer" v-else>
        <Button @click="close()" class="close-btn">关闭</Button>
      </div>
	  
	  <Modal v-model="optionModel" title="原因" :styles="{top:'140px'}"  @on-ok="examineNoPass()" @on-cancel="onClose" width="480">
	    <Form ref="examineModel" :label-width="20" :rules="ruleValidate" :model="examineModel">
	      <FormItem prop="examineText">
	        <Input v-model="examineModel.examineText" type="textarea" placeholder="请输入">
	        </Input>
	      </FormItem>
	    </Form>
	    <div slot="footer">
	      <Button @click="onClose">取消</Button>
	      <Button type="primary" @click="examineNoPass()">确定</Button>
	    </div>
	  </Modal>
	  <Modal v-model="optionModelZXDS" title="原因" :styles="{top:'140px'}"  @on-ok="examineNoPassZXDS()" @on-cancel="onClose" width="480">
	    <Form ref="examineModel" :label-width="20" :rules="ruleValidate" :model="examineModel">
	      <FormItem prop="examineText">
	        <Input v-model="examineModel.examineText" type="textarea" placeholder="请输入">
	        </Input>
	      </FormItem>
	    </Form>
	    <div slot="footer">
	      <Button @click="onClose">取消</Button>
	      <Button type="primary" @click="examineNoPassZXDS()">确定</Button>
	    </div>
	  </Modal>
    </Modal>
  </div>
</template>
<script>
import Util from '../../../lib/util'
import QuotationDetail from './quotationDetail.vue'
import ContractDetail from './contractDetail.vue'
import SettlementDetail from './settlementDetail.vue'
import AfterSalesDetail from './afterSalesDetail.vue'
import {
  getAllCustomerById,
 customerExamine,
 customerExamineNoPass,
 customerDirectorExamine,
 customerDirectorExamineNoPass
} from '../../../api/index'
export default {
  name: 'customer',
  props: {
	  show: Boolean, //弹窗 窗口显示
    id: {
      type: [String, Number],
    },
	examineName:String,
  },
  data() {
    return {
      DFMLog: [],
      JHSCBLog: [],
      jhOldListShow: false,
      productName: '',
      form: {
        customId: null,
        customModelNo: null,
        contractNumber: null,
        deliveryTime: null,
        abpUserId: null,
        jsxY_IsUploadJSXY: null,
        jsxY_Description: null,
        jsxY_IsUploadContract: null,
        jsxY_ContractDescription: null,
        tzxF_HaveBOM: null,
        tzxF_BOMTime: null,
        tzxF_Have2D: null,
        tzxF_2DTime: null,
        tzxF_HaveGYD: null,
        tzxF_GYDTime: null,
        tzxF_HaveJSXY: null,
        tzxF_JSXYTime: null,
        status: null,
        xM_SubmitTime: null,
        processCompletionTime: null,
        customer: {
          creatorUser: null,
          业务员Info: null,
          c客户名: null,
          c城市: null,
          c地址: null,
          c业务员: null,
          guid: null,
          concurrencyStamp: null,
          creationTime: null,
          creatorUserId: null,
          lastModifierUserId: null,
          lastModificationTime: null,
          deleterUserId: null,
          deletionTime: null,
          isDeleted: null,
          id: null,
        },
        customerName: null,
        userName: null,
        creatorUser: {
          job: '',
          weChatAccount: '',
          wxOpenId: null,
          city: null,
          companyName: null,
          normalizedUserName: null,
          normalizedEmailAddress: null,
          concurrencyStamp: null,
          tokens: null,
          deleterUser: null,
          creatorUser: null,
          lastModifierUser: null,
          authenticationSource: null,
          userName: null,
          tenantId: null,
          emailAddress: null,
          name: null,
          surname: null,
          fullName: null,
          password: null,
          emailConfirmationCode: null,
          passwordResetCode: null,
          lockoutEndDateUtc: null,
          accessFailedCount: null,
          isLockoutEnabled: true,
          phoneNumber: null,
          isPhoneNumberConfirmed: false,
          securityStamp: null,
          isTwoFactorEnabled: null,
          logins: null,
          roles: null,
          claims: null,
          permissions: null,
          settings: null,
          isEmailConfirmed: null,
          isActive: null,
          isDeleted: null,
          deleterUserId: null,
          deletionTime: null,
          lastModificationTime: null,
          lastModifierUserId: null,
          creationTime: null,
          creatorUserId: null,
          id: null,
        },
        deliveryTimeFormat: null,
        tzxF_BOMTimeFormat: null,
        tzxF_2DTimeFormat: null,
        tzxF_GYDTimeFormat: null,
        tzxF_JSXYTimeFormat: null,
        projectProductDtos: [],
        技术协议_Files: [],
        合同_Files: [],
        项目评审表格_Files: [],
        项目管理点检清单_Files: [],
        发货记录_List: [],
        签收单_Files: [],
        projectProducts: [],
        statusText: null,
        isEdit: null,
        isDelete: null,
        isAddProduct: null,
        isSubmitProject: null,
        isDetails: null,
        isJSXYWSC: null,
        isHTWSC: null,
        isSJBGJCX: null,
        isXMPSBGWSC: null,
        isDFM: null,
        isTZXFWTX: null,
        isSCJHYSC: null,
        isFHJLWSC: null,
        isFQSHRW: null,
        isXMGLDJQDYSC: null,
        id: null,
        submitText: null,
        submitUser: null,
        jsxySubmitTimeText: null,
        jsxySubmitUser: null,
        contractSubmitTimeText: null,
        contractSubmitUser: null,
        projectReviewSubmitTimeText: null,
        projectReviewSubmitUser: null,
        productionPlanSubmitTimeText: null,
        productionPlanSubmitUser: null,
      },
	  isDetail:false,
      spinShow: false,
	  tabName:'',
	  optionModel:false,
	  optionModelZXDS:false,
	  examineModel:{
		  id:0,
		  examineText:""
	  },
	  ruleValidate: {
	    examineText: [{ required: true, message: '请输入不通过原因', trigger: 'change' }],
	  },
    }
  },
  mounted() {
    if (this.id) {
      this.spinShow = true
      this.getDetail()
    }
  },
  components: {
    QuotationDetail,
    ContractDetail,
    SettlementDetail,
    AfterSalesDetail,
  },
  methods: {
    //获取项目详情
    async getDetail() {
	  const data = await getAllCustomerById({ guid: this.id })
	  this.form = { ...data.data.result }
      this.spinShow = false
    },
    downFile(id, name) {
      let _this = this
      let consturl = `${this.$constDefinition.baseUrl}/api/Export/ExportCHPSProductData?id=${id}` //下载地址url
      var xhr = new XMLHttpRequest()
      xhr.open('get', consturl, true) // get、post都可
      xhr.responseType = 'blob'
      xhr.setRequestHeader('Authorization', `Bearer ${Util.abp.auth.getToken()}`) //加请求头
      xhr.onload = function () {
        if (xhr.status == 200) {
          let blob = new Blob([this.response], {
            type: 'application/vnd.ms-excel',
          })
          var a = document.createElement('a')
          var url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = `模具出货评审单(${name})` // 文件名
          if (xhr.readyState === 4) {
            _this.$Message.success({
              content: '下载成功',
            })
          }
        } else {
          _this.$Message.error({
            content: '下载失败',
          })
        }
        a.click()
        window.URL.revokeObjectURL(url)
      }
      xhr.send()
    },
    preview(url) {
      let openUrl = url.replace('cover', 'preview')
      window.open(this.$constDefinition.baseUrl + openUrl)
    },
    //打开工单
    openWork(name) {
      let _this = this
      console.log(123)
      this.$Modal.confirm({
        title: '确认打开【' + name + '】吗？',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          window.open(
            '/#/unacceptedProductProcessOrders/unacceptedProductProcessOrder?workName=' + name
          )
          // _this.$router.push({
          //   path: '/unacceptedProductProcessOrders/unacceptedProductProcessOrder',
          //   query: { workName: name },
          // })
        },
      })
    },
	close() {
	  this.$emit('close')
	  this.form= {}
	},
	//关闭抽屉
	onClose() {
	  this.optionModel = false
	  this.optionModelZXDS = false
	},
	 handleTabClick(name) {
	    this.tabName=name
	},
	async passCW(){
		this.examineModel.id=this.form.id;
		let res = await customerExamine(this.examineModel)
		if (res.data.success) {
		  this.$Message.success('审核成功')
		} else {
		  this.$Message.success('审核失败')
		}
		this.close()
		this.$emit('getTab')
	},
	async noPassCW(){
	    this.examineModel.id=this.form.id
		this.optionModel = true		
	},
	async examineNoPass() {
	  this.$refs['examineModel'].validate(async (valid) => {
	    if (valid) {
			this.spinShow = true
	      let res = await customerExamineNoPass(this.examineModel)
	      if (res.data.success) {
	        this.$Message.success({ content: '审核成功', duration: 5 })
			this.onClose()
			this.spinShow = false
			this.close()
			this.$emit('getTab')
	      } else {
	        this.$Message.error({ content: '审核失败', duration: 5 })
			this.onClose()
			this.spinShow = false
			this.close()
			this.$emit('getTab')
	      }
		  }})
	},
	async passZXDS(){
		this.examineModel.id=this.form.id;
		let res = await customerDirectorExamine(this.examineModel)
		if (res.data.success) {
		  this.$Message.success('审核成功')
		} else {
		  this.$Message.success('审核失败')
		}
		this.close()
		this.$emit('getTab')
	},
	async noPassZXDS(){
	    this.examineModel.id=this.form.id
		this.optionModelZXDS = true		
	},
	async examineNoPassZXDS() {
	  this.$refs['examineModel'].validate(async (valid) => {
	    if (valid) {
			this.spinShow = true
	      let res = await customerDirectorExamineNoPass(this.examineModel)
	      if (res.data.success) {
	        this.$Message.success({ content: '审核成功', duration: 5 })
			this.onClose()
			this.spinShow = false
			this.close()
			this.$emit('getTab')
	      } else {
	        this.$Message.error({ content: '审核失败', duration: 5 })
			this.onClose()
			this.spinShow = false
			this.close()
			this.$emit('getTab')
	      }
		  }})
	},
  },
}
</script>
<style lang="less" scoped>
.project {
  max-height: 700px;
  overflow: auto;
  .top {
    background: #ececec;
    padding: 5px 5px;
    border-radius: 5px;
    .ivu-col {
      font-size: 14px;
      padding: 4px 0px;
    }
  }
}
.date_user {
  margin-left: 10px;
  margin-top: 10px;
}
.tag_wrap {
  padding: 5px 0px;
}
.tag_area {
  padding: 3px 8px;
  border: 1px solid #2d8cf0;
  background: #fff;
  border-radius: 3px;
  margin-right: 5px;
  color: #2d8cf0;
  cursor: pointer;
}
.product {
  margin: 5px 0px;
}
.sw {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
}
.m-hei {
  max-height: 600px;
  overflow: auto;
}
.tit {
  padding: 5px 5px;
  background: rgb(179, 179, 179);
  //    border-radius: 5px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.jybg {
  background: rgb(212, 212, 212);
  border-radius: 5px;
  margin-top: 5px;
  //   padding: 5px;
}
.padding {
  padding: 0px 5px;
  display: flex;
  flex-wrap: wrap;
}
.productName {
  color: #2d8cf0;
  // border-bottom: 1px solid #ddd;
}
.dfm {
  background: rgb(236, 236, 236);
  border-radius: 5px;
  padding: 10px;
  margin: 10px;
}
.dfmdata {
  margin-left: 10px;
  color: rgb(163, 163, 163);
}
.tzxfYes {
  color: #47cb89;
}
.tzxfNo {
  color: #f16643;
}
.t {
  cursor: pointer;
}
.wrap {
  height: 400px;
  overflow: auto;
  padding-right: 10px;
}
.modeTab,
.modeTab tr,
.modeTab td,
.modeTab th {
  border: 1px solid rgb(134, 134, 134);
  border-collapse: collapse;
  text-align: center;
}
.modeTab {
  width: 100%;
  margin-top: 15px;
}
td,
th {
  padding: 8px 6px;
}
.dt {
  display: flex;
  justify-content: center;
  max-width: 100%;
}
.href {
  color: #2d8cf0;
  border: 1px solid #2d8cf0;
  padding: 2px;
  cursor: pointer;
}
.fileList {
  display: flex;
  flex-wrap: wrap;
  .filename {
    width: 80px;
    word-break: break-all;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden; //溢出内容隐藏
    text-overflow: ellipsis; //文本溢出部分用省略号表示
    display: -webkit-box; //特别显示模式
    -webkit-line-clamp: 2; //行数
    line-clamp: 2;
    -webkit-box-orient: vertical; //盒子中内容竖直排列
  }
}
.img {
  margin-right: 10px;
}
.pos {
  position: relative;
}
.pos:hover .img_magnify {
  display: inline-block;
}
.ico {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.img_magnify {
  display: none;
  background: rgba(0, 0, 0, 0.459);
  position: absolute;
  z-index: 1;
  width: 80px;
  height: 80px;
  left: 0px;
  right: 0;
  top: 0;
  bottom: 0;
}
.img_wrap {
  display: flex;
  flex-direction: column;
  padding: 5px 0px;
}
</style>